export default "__VITE_ASSET__CqbkdKkk__"